import logoTextImage from "#assets/logo-text-orange.svg";
import SpinningLogo from "./SpinningLogo.tsx";

export default function SpinningTradeLogo() {
	return (
		<div className="flex flex-col items-center mt-2">
			<SpinningLogo
				variant="orange"
				className="max-w-[125px] min-h-[80px] fill-amber-400"
			/>
			<img
				alt="Stringiverse brand"
				src={logoTextImage}
				className="h-[80px] place-self-start -mt-6"
			/>
		</div>
	);
}
